module.exports = __webpack_public_path__ + "img/contrology-classical@2x.2a0f2dea.png";